import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { useTranslation } from 'react-i18next';
import { ESettingsWorkspaceTab } from '../ESettingsWorkspaceTab';
import { TabSettingsWorkspaceWrapper } from '../_base/TabSettingsWorkspaceWrapper';
import { USViewWorkspaceActiveSubscription } from '../credits_top_up/USViewWorkspaceActiveSubscription';

export const TabSettingsWorkspaceSubscription = () => {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  return (
    <TabSettingsWorkspaceWrapper type={ESettingsWorkspaceTab.SUBSCRIPTION} required_owner_access>
      <div className="flex flex-col justify-start items-start mt-2 gap-3  text-page-foreground">
        <span className="text-xl">{t(i18n_page_settings_workspace.tabs.credits.general_component.title)}</span>

        <div className="w-9" />

        <USViewWorkspaceActiveSubscription />

        <div className={`flex flex-wrap   items-center  ${md(' justify-between w-full gap-x-4 gap-y-4', ' justify-start w-[60rem] gap-10')}`}></div>
      </div>
    </TabSettingsWorkspaceWrapper>
  );
};
